import React from 'react';
import chatRobot from '@/imgs/chat-robot.gif';
interface AvatarProps {
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ className = '' }) => {
  return (
    <div className={`relative ${className}`}>
      <div className="h-[52px] w-[52px] rounded-full p-[1px]">
        <img src={chatRobot} alt="" width={52} height={52} className="scale-[1.2]" />
      </div>
    </div>
  );
};

export default Avatar;
